import type { FlowContext } from '@/types'

// --- Sex ---
export const isMale = (ctx: FlowContext) => ctx.vars.sexo === 'masculino'
export const isFemale = (ctx: FlowContext) => ctx.vars.sexo === 'feminino'

// --- Age ---
export const isAdult = (ctx: FlowContext) => Number(ctx.vars.idade) >= 18
export const isMinor = (ctx: FlowContext) => Number(ctx.vars.idade) < 18
export const isOver30 = (ctx: FlowContext) => Number(ctx.vars.idade) >= 30
export const isOver50 = (ctx: FlowContext) => Number(ctx.vars.idade) >= 50

// --- IMC ---
export const isUnderweight = (ctx: FlowContext) => Number(ctx.vars.imc) < 18.5
export const isNormalWeight = (ctx: FlowContext) => {
  const imc = Number(ctx.vars.imc)
  return imc >= 18.5 && imc < 25
}
export const isOverweight = (ctx: FlowContext) => Number(ctx.vars.imc) >= 25
export const isObese = (ctx: FlowContext) => Number(ctx.vars.imc) >= 30

// --- Combinators ---
export const and =
  (...fns: ((ctx: FlowContext) => boolean)[]) =>
  (ctx: FlowContext) =>
    fns.every((fn) => fn(ctx))

export const or =
  (...fns: ((ctx: FlowContext) => boolean)[]) =>
  (ctx: FlowContext) =>
    fns.some((fn) => fn(ctx))

export const not = (fn: (ctx: FlowContext) => boolean) => (ctx: FlowContext) => !fn(ctx)

// --- Objective ---
export const isObjective = (obj: string) => (ctx: FlowContext) => {
  if (ctx.vars.objetivo === obj) return true
  return Array.isArray(ctx.vars.objetivos) && ctx.vars.objetivos.includes(obj)
}
